import React, {useEffect, useRef, useState} from 'react';
import {
  createRevisionScope, deleteRevisionScope,
  getAllRevisionScope,
  updateRevisionScope,
} from '../../../services/revisionScope/revisionScope';
import {getLanguage, t} from 'react-switch-lang';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import Swal from 'sweetalert2';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from '../Metodologies/plus.png';
import CustomTable from '../../../components/customTable/CustomTable';
import {getAllRevisionTypes} from '../../../services/revisionTypes/revisionTypes';

const RevisionScope = () => {
  const [revisionScope, setRevisionScope] = useState([])
  const [query, setQuery] = useState()
  const [revisionTypes, setRevisionTypes] = useState([]);

  const formatedRevisionTypes = revisionTypes.map((d) => ({
    label: getLanguage() === "eng" ? d.nameEn : d.name,
    value: d.id,
  }));
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRevisionScope();
        setRevisionScope(data);
      } catch (err) {}
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllRevisionTypes();
        setRevisionTypes(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 150, message: t('message.max', {max: 150})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 150, message: t('message.max', {max: 150})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'revisionTypeId',
      nestedKey: getLanguage() === "eng" ? 'nameEn' : 'name',
      title: t('revisions.revisionType'),
      editable: true,
      placeholder:`${t('revisions.placeholder.revisionType')}`,
      inputType: 'customSelect',
      options: formatedRevisionTypes,
      render: (value) => {
        const revisionTypesLabel = formatedRevisionTypes?.find((d) => d.value === value);
        return revisionTypesLabel?.label;
      },
      rules: [
        {required: true, message: t('message.fieldRequired')},
      ],
    },
  ];
  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.id = editingRecord.id;
    try {
      const response = await updateRevisionScope(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess3', {entity: t('revisionScope.revisionsScope')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('revisionScope.revisionScopeExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('revisionScope.revisionScopeExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createRevisionScope(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess3', {entity: t('revisionScope.revisionsScope')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('revisionScope.revisionScopeExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('revisionScope.revisionScopeExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('revisionScope.revisionsScope'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteRevisionScope(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess3', {entity: t('revisionScope.revisionsScope')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'revision-scope-could-not-be-deleted') {
              Swal.fire({
                text: t('message.revisionScopeCannotDelete'),
                icon: 'error',
              });
            } else {
              Swal.fire({
                text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
                icon: 'error',
              });
            }
          }
        },
      });
    });
  };

  const addButton = useRef();
  return (
    <div className="revisionScope administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('revisionScope.searchRevisionScope')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('revisionScope.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/revision-scopes"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default RevisionScope;